import { createContext } from 'react';

// Context object lives in its own non-component module so its identity
// survives React Fast Refresh — a module mixing createContext() with
// components/hooks gets fully re-executed on hot reload, which would create
// a new context instance the already-mounted provider doesn't know about.

interface IStrategyAutomationsContext {
  strategyCardRandomIdForOpenedAutomations: number | null;
  setStrategyCardRandomIdForOpenedAutomations: React.Dispatch<
    React.SetStateAction<number | null>
  >;
}

export const StrategyAutomationsContext = createContext<
  IStrategyAutomationsContext | undefined
>(undefined);
